import RootLayout from '../Layout';
import Lottie from 'lottie-react';
import { useRouter } from 'next/router';
import startLottie from '../../const/lottie/start.json';
import home0 from '../../const/lottie/home0.json';
import home1 from '../../const/lottie/home1.json';
import home2 from '../../const/lottie/home2.json';
import home3 from '../../const/lottie/home3.json';
import styles from './index.module.scss';
import styles_mobile from './index_mobile.module.scss';
import { useEffect, useState } from 'react';
import useInitImg from '../../hooks/useInitImg';
import Img from '../Img';
import useScreenWidthBelowThreshold from '../../hooks/useScreenWidthBelowThreshold';
import OneLinkImg from '../OneLinkImg';
import Login from './login';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../stores/AuthContext';

const TitleColorMap = {
  0: '#8742ff',
  1: '#ff64cd',
  2: '#2396ff',
};


const backgroundArr = [
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkpIU0o1UVBJSkxHUE5GRlZVSkVOQk9ZTUxBUkdPVyIsInciOjM4NDAsImgiOjE1MzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMDY1NzQwNDI2MzI5NDkzMTQ4OX0?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkpQN09VSjdaVkhFU0xMRVFQSFRVQkhBU05BQTc1VCIsInciOjM4NDAsImgiOjE1MzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjo5OTAyMDg1NjI5NjYwNDY0MTI4fQ?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik8yTjIzVkFBV0xIRUo1Rk5KVlNFQzdNUjZLS0NPTyIsInciOjM4NDAsImgiOjE1MzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMjMwNTE5MTgyMjQzNzIyNjA4MX0?format=originalOFGHLERTH',
];

const backgroundArrMobile = [
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IldVSUlRN1ZUTUxYTEhaQklKVFlQWU1YTFZQNzdOUSIsInciOjc1MCwiaCI6MTMwNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjU3MTY5Mjc4NjQ0MjAyNTgxOTR9?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IlYyNllCSzJGVEJBWElUUUZaRkE1NTc1Nk5XNk5HUiIsInciOjc1MCwiaCI6MTMwNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE1MzA5MDU4MjAwODgwNjE2MzM4fQ?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IjdWVjRLRkIyU1RCWkI3UVVERkJBVFNGQTdVQVhTSSIsInciOjc1MCwiaCI6MTMwNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEwNTA2MjQ0OTkwODM4MTg4NDM0fQ?format=originalOFGHLERTH',

];

const titleArr = [home1, home2, home3];

export default function Home({ onIndexChange }) {
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(1281);
  console.log('isScreenWidthBelow700px', isScreenWidthBelow700px);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showStartLottie, setShowStartLottie] = useState(true);
  const [showInitialTitle, setShowInitialTitle] = useState(false);
  const [showNormalTitle, setShowNormalTitle] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const router = useRouter();
  const { t } = useTranslation();
  const { logged } = useAuth();

  useEffect(() => {
    if (router.query?.ref === 'producthunt') {
      // 把后缀干掉并且打一个点
      router.push('/');
      fetch('/web/event?event_name=producthunt_website_visits');
    }
  }, [router.query]);

  useEffect(() => {
    onIndexChange(activeIndex);
  }, [activeIndex, onIndexChange]);

  useInitImg([...backgroundArr, ...backgroundArrMobile]);

  useEffect(() => {
    if (showNormalTitle || isScreenWidthBelow700px) {
      const interval = setInterval(() => {
        if (isScreenWidthBelow700px) {
          setActiveIndex((index) => (index + 1) % backgroundArrMobile.length);
        } else {
          setActiveIndex((index) => (index + 1) % backgroundArr.length);
        }
      }, 9000);
      return () => clearInterval(interval);
    }
  }, [showNormalTitle, isScreenWidthBelow700px]);

  if (isScreenWidthBelow700px) {
    return (
      <>
        <RootLayout
          className={styles_mobile.wrapper}
          style={{ backgroundImage: `url(${backgroundArrMobile[activeIndex]})` }}
        >
          <>
            <Img
              className={styles_mobile.logo}
              src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjJCTUwzQ0hOR0xFN0xRUFQ2TU1DU1gyQUNVUE5URSIsInciOjIxNiwiaCI6NjQsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMDI1NTY2MTc3NTgzNDU2MzN9"
            />
            <div className={styles_mobile.buttonWrapper}>
              <div className={styles_mobile.title}>Provide  more payment options for you</div>
              <div className={styles_mobile.subtitle}>Save up to $29.99</div>
              <div className={styles_mobile.arrow} />
              <div
                target="_blank"
                className={styles_mobile.button}
                rel="noreferrer"
                style={{ color: TitleColorMap[activeIndex] }}
                onClick={() => {
                  window.open(logged ? '/playground_mobile' : '/login');
                }}
              >
                {logged ? 'CONTINUE' : 'LOGIN'}
                <div className={styles_mobile.tag} />
              </div>
            </div>

          </>
        </RootLayout>
        {
        showLogin ? <Login setShowLogin={setShowLogin} /> : null
        }
      </>

    );
  } else {
    return (
      <>
        <RootLayout
          className={styles.wrapper}
          style={{ backgroundImage: `url(${backgroundArr[activeIndex]})` }}
        >
          <>
            {
            showStartLottie &&
            <Lottie
              animationData={startLottie}
              className={styles.start}
              onComplete={() => {
                setShowStartLottie(false);
                setShowInitialTitle(true);
                setTimeout(() => {
                  setShowInitialTitle(false);
                  setShowNormalTitle(true);
                }, 2500);
              }}
              loop={false}
            />
          }
            <div className={styles.logo}>
              <div
                className={styles.loginButton}
                onClick={() => {
                  window.open('/login');
                }}
              >{t('DUET_WEB_SIGNIN_ENTRANCE')}
              </div>
              <Img
                src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjRVM0haNTdUU0ZBVzdLQldLVjJWSTRRVTdQREgzRyIsInciOjIxNiwiaCI6NjQsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMDI1NTY2MTc3NTgzNDU2MzN9"
              />
            </div>
            {showInitialTitle && <Lottie className={styles.title} animationData={home0} />}
            {showNormalTitle && <Lottie className={styles.title} animationData={titleArr[activeIndex]} />}
            <div className={styles.content}>
              <a
                href="https://duet.onelink.me/GBnZ/t3682sma"
                target="_blank"
                className={styles.one}
                rel="noreferrer"
              />
              <div className={styles.two}>GET THE APP</div>
              <div className={styles.three}>
                <OneLinkImg
                  src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlhJRTYzRTVEQkhaNjVSUllDNEJFM0NCWlc1Qk1ZVSIsInciOjMxNCwiaCI6OTYsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjo3NTUzNTQ5MTM3MDEzMjk5Mn0"
                />
                <OneLinkImg
                  src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlNEUDI1SFJXQjI3UUtMRVBTWU83RExGVkk0RkFXNiIsInciOjMxNCwiaCI6OTYsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoyNTk2MzI3MTE0MDIzMDY1Nn0"
                />
              </div>
            </div>
          </>
        </RootLayout>
        {
        showLogin ? <Login setShowLogin={setShowLogin} /> : null
        }
      </>
    );
  }
}
